import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

const HEADER_HEIGHT = 72

const navigation = [
  { name: 'Kronos köpskydd', href: '/kronos-secure' },
  { name: 'Kronos Certified', href: '/kronos-certified' },
  { name: 'Kontrollera certifiering', href: '/kronos-certified-control' },
  { name: 'Klockvärdering', href: '/klockvardering' },
  { name: 'Företagsannonsering', href: '/foretagsannonsering' },
  { name: 'Marknadsföring', href: '/marknadsforing' },
  { name: 'Blogg', href: '/blogg' },
  { name: 'Integritetspolicy', href: '/integritetspolicy' },
  { name: 'Användarvillkor', href: '/anvandarvillkor' },
]

function WatchMagazineArticle({ siteLogo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const watches = [
    {
      id: 1,
      meta: '01 • IKON',
      title: 'Seiko Prospex Turtle',
      desc: 'En av världens mest ikoniska dykarklockor med stark historia och otrolig komfort på handleden.',
      specs: {
        vatten: '200 m vattentäthet',
        glas: 'Hardlex-glas',
        gång: '41 h gångreserv',
      },
      price: '6 000–9 000 kr',
      img: require('./seiko-turtle.png'),
      url: 'https://www.seikowatches.com/global-en/products/prospex',
    },
    {
      id: 2,
      meta: '02 • JAPANSK VALUE',
      title: 'Citizen Promaster Diver',
      desc: 'ISO-certifierad dykare med Eco-Drive som drivs av ljus och kräver minimalt underhåll.',
      specs: {
        vatten: '200 m vattentäthet',
        glas: 'Mineralglas',
        gång: 'Ljusdriven',
      },
      price: '3 500–5 000 kr',
      img: require('./citizen.png'),
      url: 'https://www.citizenwatch-global.com/promaster/marine/',
    },
    {
      id: 3,
      meta: '03 • BÄST FÖR PENGARNA',
      title: 'Orient Kamasu',
      desc: 'Automatisk dykare med safirglas och imponerande byggkvalitet för priset.',
      specs: {
        vatten: '200 m vattentäthet',
        glas: 'Safirglas',
        gång: '40 h gångreserv',
      },
      price: '3 000–5 000 kr',
      img: require('./kamasu.png'),
      url: 'https://www.orient-watch.com/',
    },
    {
      id: 4,
      meta: '04 • SCHWEIZISK ENTRY',
      title: 'Tissot Seastar 1000',
      desc: 'Keramisk bezel och 300 m vattentäthet med tydlig premiumkänsla från Schweiz.',
      specs: {
        vatten: '300 m vattentäthet',
        glas: 'Safirglas',
        gång: '80 h gångreserv',
      },
      price: '8 000–10 000 kr',
      img: require('./tissot.png'),
      url: 'https://www.tissotwatches.com/en-se/collection/main-collections/tissot-seastar.html',
    },
    {
      id: 5,
      meta: '05 • TOOL WATCH',
      title: 'Certina DS Action Diver',
      desc: 'Extremt robust schweizisk toolwatch byggd för vardag och dykning.',
      specs: {
        vatten: '300 m vattentäthet',
        glas: 'Safirglas',
        gång: '80 h gångreserv',
      },
      price: '9 000–10 000 kr',
      img: require('./certina.png'),
      url: 'https://www.certina.com/se/ds-action?gad_source=1&gad_campaignid=20077519344&gbraid=0AAAAApZo0UiaCbielbBNhweF5IlODDBuQ&gclid=CjwKCAjwrNrQBhBjEiwAoR4VO3Sygn78UvqP8Lg3kCcp5E7whK87UjFvC6kYYThaoR-e1MDudlBiJxoCjO4QAvD_BwE',
    },
    {
      id: 6,
      meta: '06 • VARDAGSDYKARE',
      title: 'Seiko 5 Sports',
      desc: 'Sportig och tålig vardagsdykare med klassisk Seiko-känsla.',
      specs: {
        vatten: '100–200 m vattentäthet',
        glas: 'Hardlex-glas',
        gång: '41 h gångreserv',
      },
      price: '3 000–6 000 kr',
      img: require('./seiko-gmt.png'),
      url: 'https://www.seikowatches.com/global-en/products/5sports',
    },
    {
      id: 7,
      meta: '07 • CASIO LEGEND',
      title: 'Casio Duro (MDV-106)',
      desc: 'En kultförklarad budgetdykare som blivit älskad av entusiaster världen över.',
      specs: {
        vatten: '200 m vattentäthet',
        glas: 'Mineralglas',
        gång: 'Batteri',
      },
      price: '800–1 500 kr',
      img: require('./casio.png'),
      url: 'https://www.casio.com/',
    },
    {
      id: 8,
      meta: '08 • SCHWEIZISK TOOL DIVER',
      title: 'Squale 1545',
      desc: 'Schweizisk tool diver med vintageinspirerad design och professionell känsla.',
      specs: {
        vatten: '300 m vattentäthet',
        glas: 'Safirglas',
        gång: 'Swiss automatic',
      },
      price: '8 000–10 000 kr',
      img: require('./squale.png'),
      url: 'https://www.squale.ch/en/squale-1545',
    },
    {
      id: 9,
      meta: '09 • MODERN DESIGN',
      title: 'Spinnaker Fleuss',
      desc: 'Microbrand med retrodesign och mycket klocka för pengarna.',
      specs: {
        vatten: '150–200 m vattentäthet',
        glas: 'Mineralglas',
        gång: 'Automatisk',
      },
      price: '2 000–4 000 kr',
      img: require('./spinnaker.png'),
      url: 'https://spinnaker-watches.com/collections/fleuss?srsltid=AfmBOoo1jVyd-rDsS8is39On-3C3vOIdlipdlh-cuO3OIE7HMKbk1MpI',
    },
    {
      id: 10,
      meta: '10 • PREMIUM KÄNSLA',
      title: 'Hamilton Khaki Navy Scuba',
      desc: 'Schweizisk sportdykare med stark närvaro och premiumkänsla.',
      specs: {
        vatten: '100–200 m vattentäthet',
        glas: 'Safirglas',
        gång: 'Swiss automatic',
      },
      price: '8 000–10 000 kr',
      img: require('./hamilton.png'),
      url: 'https://www.hamiltonwatch.com/sv-se/collection/khaki-navy.html?srsltid=AfmBOooGvPzNr2l7tifNF_b1oEFaGWetUdJIOH1htcfd0pYWi8pOVC7o',
    },
    {
      id: 11,
      meta: '11 • SCHWEIZISK TOOL WATCH',
      title: 'Mido Ocean Star 200',
      desc: 'Välbyggd schweizisk dykare med stark finish och vardagsfunktion.',
      specs: {
        vatten: '200 m vattentäthet',
        glas: 'Safirglas',
        gång: '80 h gångreserv',
      },
      price: '8 000–10 000 kr',
      img: require('./mido.png'),
      url: 'https://www.midowatches.com/en/watches/collections/ocean-star/ocean-star-200.html?srsltid=AfmBOopOATihu8KG8OPuJUuwHEq459av4bw1qF9bMNqoXqHsF5yDkCBR',
    },
    {
      id: 12,
      meta: '12 • FRANSK DESIGNIKON',
      title: 'Yema Superman',
      desc: 'Fransk designikon med unik bezel-låsning och tydlig vintagekaraktär.',
      specs: {
        vatten: '300 m vattentäthet',
        glas: 'Safirglas',
        gång: 'Automatisk',
      },
      price: '8 000–10 000 kr',
      img: require('./yema.png'),
      url: 'https://yema.com/collections/superman?srsltid=AfmBOorqyO6XfD3_QOdCt1jyrmwJiECY-vMgZ-N68mnT_wFq8xszpXk6',
    },
  ]

  return (
    <div className="bg-[#f4f3f0] text-black min-h-screen">
      {/* HEADER */}
      {/* Header */}
      <header className="fixed inset-x-0 top-0 z-50 bg-white shadow">
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <a href="/" className="flex items-center -m-1.5 p-1.5">
            <span className="sr-only">Krono</span>
            <img alt="Krono Logo" src={siteLogo} className="h-6 w-auto rounded-md" />
          </a>

          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <button
              type="button"
              className="p-2.5 text-gray-700 rounded-md"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>

          {/* Desktop navigation */}
          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-gray-900 hover:underline"
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>

        {/* Mobile menu */}
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-white px-6 py-6 overflow-y-auto shadow-lg">
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="p-2.5 text-gray-700 rounded-md"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      {/* HERO */}
      <section
        className="flex items-center justify-center text-center px-6"
        style={{
          height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          backgroundImage:
            "linear-gradient(to bottom, rgba(255,255,255,.15), rgba(244,243,240,.98)), url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1800&auto=format&fit=crop')",
          backgroundSize: 'cover',
        }}
      >
        <div className="max-w-4xl">
          <div className="inline-block px-5 py-2 rounded-full bg-white/60 backdrop-blur text-md font-extrabold tracking-widest mb-8">
            DYKARKLOCKOR UNDER 10 000 KR
          </div>

          <h1 class="text-5xl md:text-8xl font-black leading-[1.2] mb-8">
            12 prisvärda
            <br />
            dykarklockor för sommaren 2026
          </h1>

          <p className="text-lg text-gray-700 font-poppins">
            Soliga dagar, saltvatten, sena kvällsdopp och spontana äventyr.
          </p>
          <p className="text-lg text-gray-700 font-poppins">
            Här är våra favoriter bland marknadens mest prisvärda dykarklockor under 10 000 kronor.
          </p>
        </div>
      </section>

      {/* GRID */}
      <section className="max-w-7xl mx-auto px-6 py-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {watches.map((w) => (
          <a key={w.id} href={w.url} target="_blank" rel="noreferrer" className="group">
            <article className="bg-white rounded-[28px] overflow-hidden shadow-sm hover:shadow-xl transition">
              {/* IMAGE */}
              <div className="relative h-[380px] overflow-hidden">
                <img
                  src={w.img}
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-[1200ms]"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />

                <div className="absolute top-5 left-5">
                  <span className="text-[11px] tracking-[0.25em] uppercase text-white bg-black/40 backdrop-blur px-3 py-1 rounded-full">
                    {w.meta}
                  </span>
                </div>
              </div>

              {/* CONTENT */}
              <div className="p-7">
                <h3 className="text-xl font-semibold mb-2 group-hover:translate-x-1 transition">
                  {w.title}
                </h3>

                <p className="text-sm text-gray-600 mb-5">{w.desc}</p>

                {/* LABELS (SVENSKA) */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {Object.values(w.specs).map((item, i) => (
                    <span
                      key={i}
                      className="text-[11px] uppercase tracking-[0.12em]
                                 px-3 py-1 rounded-full
                                 bg-black/5 text-black/70 border border-black/5"
                    >
                      {item}
                    </span>
                  ))}
                </div>

                <div className="flex justify-between border-t pt-5 border-black/5">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-gray-400">Pris</span>
                  <span className="text-sm font-medium">c.a {w.price}</span>
                </div>
              </div>
            </article>
          </a>
        ))}
      </section>

      {/* FOOTER */}
      <footer className="text-start pb-24 px-6 text-gray-600 max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-3xl font-bold text-black mb-6 tracking-tight font-poppins">
          Sommaren börjar vid havet, och fortsätter på handleden
        </h3>

        <p className="text-base leading-relaxed mb-6 font-poppins">
          En dykarklocka behöver inte vara logisk. Den behöver bara kännas rätt. Vissa dras till
          tung, verktygslik närvaro. Andra vill ha något lätt, klassiskt eller nästan diskret.
        </p>

        <p className="text-base leading-relaxed mb-6 font-poppins">
          Smak är inget man räknar ut. Den byggs långsamt, genom intryck, känslor och små detaljer
          du knappt kan förklara. En bezel som klickar rätt. Ett glas som fångar ljuset på rätt
          sätt. En tavla som bara känns självklar.
        </p>

        <p className="text-base leading-relaxed mb-10 font-poppins">
          Så ta den här listan för vad den är, inte en ranking, utan en samling olika
          personligheter. Någon kommer kännas helt rätt direkt. Resten är bara steg på vägen till
          att hitta din egen stil.
        </p>

        {/* EDITOR NOTE */}
        <div className="border-t pt-6 border-gray-200">
          {/* <div className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-4">
              Redaktörens not
            </div> */}

          <div className="flex items-center justify-between">
            <div>
              <div className="font-semibold text-black font-poppins">Redaktion Kronos</div>
              <div className="text-sm text-gray-500 font-poppins">Dykarklockor sommar • 2026</div>
            </div>

            <div className="text-sm font-black text-black opacity-20 ">2026-05-28</div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default WatchMagazineArticle
